import { render, staticRenderFns } from "./RawMaterialDetailComponent.vue?vue&type=template&id=54e63b0a&scoped=true&"
import script from "./RawMaterialDetailComponent.vue?vue&type=script&lang=js&"
export * from "./RawMaterialDetailComponent.vue?vue&type=script&lang=js&"
import style0 from "./RawMaterialDetailComponent.vue?vue&type=style&index=0&id=54e63b0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e63b0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
installComponents(component, {VBreadcrumbs})
